import { render, staticRenderFns } from "./ProgramReach.vue?vue&type=template&id=04644539&scoped=true&"
import script from "./ProgramReach.vue?vue&type=script&lang=js&"
export * from "./ProgramReach.vue?vue&type=script&lang=js&"
import style0 from "./ProgramReach.vue?vue&type=style&index=0&id=04644539&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04644539",
  null
  
)

export default component.exports